export const PAYMENT_TYPE_IDS = {
    SEPA_DIRECT_DEBIT: '550e8400-e29b-41d4-a716-446655440001',
    SINGLE_CARD_PAYMENT: '550e8400-e29b-41d4-a716-446655440002',
    CARD_SUBSCRIPTION: '550e8400-e29b-41d4-a716-446655440003',
} as const;

export const PAYMENT_TYPE_NAMES: Record<string, string> = {
    [PAYMENT_TYPE_IDS.SEPA_DIRECT_DEBIT]: 'Domiciliación bancaria (SEPA)',
    [PAYMENT_TYPE_IDS.SINGLE_CARD_PAYMENT]: 'Pago único con tarjeta',
    [PAYMENT_TYPE_IDS.CARD_SUBSCRIPTION]: 'Suscripción con tarjeta',
};
